import clsx from 'clsx';
import Image from 'next/image';

export interface PriorityImageProps {
  src: string;
  alt: string;
  className?: string;
  testId?: string;
}

export default function PriorityImage({
  src,
  alt,
  className,
  testId,
}: PriorityImageProps): JSX.Element | null {
  return (
    <div className={clsx('relative w-full', className)}>
      <Image
        data-testid={testId ?? 'priority-image'}
        className='object-contain'
        src={src}
        alt={alt}
        priority
        fill
        unoptimized // This allows crucial images to remain clear (i.e. Membership Card logos)
      />
    </div>
  );
}
